import { Clock3, Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

type TimelineEmptyStateProps = {
  disabled?: boolean;
  onCreateEvent: () => void;
};

export function TimelineEmptyState({
  disabled = false,
  onCreateEvent,
}: TimelineEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <Card className="border-dashed">
      <CardContent className="flex flex-col items-center gap-4 px-6 py-12 text-center">
        <div className="rounded-full bg-secondary/70 p-4 text-secondary-foreground">
          <Clock3 className="h-6 w-6" />
        </div>
        <div className="space-y-2">
          <h2 className="text-2xl text-foreground">{t("timeline.empty.title")}</h2>
          <p className="max-w-xl text-sm leading-7 text-muted-foreground">
            {t("timeline.empty.body")}
          </p>
        </div>
        <Button disabled={disabled} onClick={onCreateEvent} type="button">
          <Plus className="h-4 w-4" />
          {t("timeline.empty.action")}
        </Button>
      </CardContent>
    </Card>
  );
}
